module.exports = __webpack_public_path__ + "img/pin-restaurant.77b27704.png";